import React from 'react';

// Context
import { useCompareContext } from '@/context/compare';

import { toggleExpandedCompareTray } from '@/braun/Controllers/CompareTrayController';

const CompareProductEmpty = () => {
  const [{ openCompare }] = useCompareContext();

  return (
    <button
      className='bra-compareTray__addProd'
      type='button'
      onClick={() => {
        toggleExpandedCompareTray('shrink');
        openCompare(false);
      }}
    >
      <span className='bra-compareTray__addProdIconWrap'>
        <i className='bra-icn bra-icn__plus' data-class=' bra-icn__plus' />
      </span>
    </button>
  );
};

export default CompareProductEmpty;
